const API_BASE_URL = import.meta.env.VITE_APP_BASE_URL ?? ''
// Media is served from the host root, not the /api prefix.
const MEDIA_BASE_URL = API_BASE_URL.replace(/\/api\/?$/, '')

const DEFAULT_AVATAR = '/images/user-3296.svg'

/**
 * Absolute URL for anything the backend serves out of `/media` — avatars, chat
 * attachments, task condition files.
 *
 * Two corrections the backend leaves to us, and both bite silently:
 *   - the path comes back relative (`/media/…`), and media lives at the host
 *     root, NOT under the `/api` prefix — keeping the prefix 404s;
 *   - the URL sometimes arrives as `http://`, which an https-served page blocks
 *     as mixed content, so the file never loads.
 *
 * Returns null for an empty path so callers can decide what "no file" looks
 * like; `resolveImageUrl` turns that into the placeholder avatar.
 */
export function resolveMediaUrl(path?: string | null): string | null {
  if (!path) return null

  const url = path.startsWith('http')
    ? path
    : `${MEDIA_BASE_URL}${path.startsWith('/') ? path : `/${path}`}`

  // Left untouched in local http dev so plain-http backends keep working.
  if (
    typeof window !== 'undefined' &&
    window.location.protocol === 'https:' &&
    url.startsWith('http://')
  ) {
    return `https://${url.slice('http://'.length)}`
  }
  return url
}

/** Media URL with the placeholder avatar as the fallback. */
export function resolveImageUrl(path?: string | null): string {
  return resolveMediaUrl(path) ?? DEFAULT_AVATAR
}
